import React from 'react';
import { useAlloyFeatureFlag } from '@adsk/alloy-provider';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';
import Tooltip, { OverflowTooltip } from '@adsk/alloy-react-tooltip';
import { MFATooltipContent } from './MFATooltipContent';
export const MFAIcon = _ref => {
  let {
    containerRef
  } = _ref;
  const {
    value: mfaSetupRequired
  } = useAlloyFeatureFlag('mfa-setup-required', undefined);
  if (!mfaSetupRequired) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Tooltip, {
    triggerTarget: OverflowTooltip.TRIGGER_TARGETS.TOOLTIP,
    content: /*#__PURE__*/React.createElement(MFATooltipContent, null),
    shouldWrapChildren: false,
    container: containerRef
  }, /*#__PURE__*/React.createElement(AlertWarningIcon, {
    "data-testid": "MFAIcon",
    style: {
      margin: "auto ".concat(theme.spacing.xSmall, "px"),
      color: theme.colors.yellowOrange500
    }
  }));
};
//# sourceMappingURL=MFAIcon.js.map